import {createElement, Fragment, memo} from 'react'

function HighlightedText({
    searchText = '',
    text,
    highlightElement = 'mark',
}: {
    searchText?: string
    text?: string | null
    highlightElement?: string
}) {
    if (!text) {
        return null
    }

    if (searchText === '' || searchText.length > text.length) {
        return <>{text}</>
    }

    const escapedText = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const parts = text.split(new RegExp(`(${escapedText})`, 'gi'))

    return (
        <>
            {parts.map((part, i) => {
                const matched = part.toLocaleLowerCase() === searchText.toLocaleLowerCase()
                if (matched) {
                    return createElement(highlightElement, {key: i}, part)
                } else {
                    return <Fragment key={i}>{part}</Fragment>
                }
            })}
        </>
    )
}

export default memo(HighlightedText)
